import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TableModel } from 'src/app/models/table.model';
import { Observable } from 'rxjs';
import { PagedPaymentLogModel } from '../models/paged.payment.log.model';

@Injectable()
export class PaymentLogService {

    constructor(private http: HttpClient) { }

    list(tableModel: TableModel): Observable<PagedPaymentLogModel> {
        let url = `${environment.apiUrl}/api/admin/payment/list`;
        const queryParams = [];
        if (tableModel) {
            queryParams.push(tableModel.toQueryString());
        }
        if (queryParams.length) {
            url += '?' + queryParams.join('&');
        }
        return this.http.get<PagedPaymentLogModel>(url);
    }
}
